// Empresa
const path = 'companies/'
const list = ({ opt = {} }) => axios.get(path, opt)
const create = ({ form, opt = {} }) => axios.post(path, form, opt)
const edit = ({ pk, form, opt = {} }) => axios.put(`${path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${path}${pk}/`, opt)
const tenantGuide = ({ pk, opt = {} }) =>
  axios.get(`${path}${pk}/tenant-guide/`, opt)
const remove = ({ pk }) => axios.delete(`${path}${pk}/`)
const download_backup = ({ pk, opt = {} }) =>
  axios.get(`${path}${pk}/download-backup/`, opt)
const restore_backup = ({ pk, form, opt = {} }) =>
  axios.post(`${path}${pk}/restore-backup/`, form, opt)

// Contactos de empresa
const path2 = 'company-contact/'
const path3 = 'contact-type/'
const contact = {
  list: ({ opt = {} }) => axios.get(path2, opt),
  create: ({ form, opt = {} }) => axios.post(path2, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${path2}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${path2}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${path2}${pk}/`),
  type: {
    list: ({ opt = {} }) => axios.get(path3, opt),
    create: ({ form, opt = {} }) => axios.post(path3, form, opt),
    edit: ({ pk, form, opt = {} }) => axios.put(`${path3}/${pk}/`, form, opt),
    remove: ({ pk }) => axios.delete(`${path3}/${pk}/`)
  }
}

// Impuestos de empresa
const path4 = 'company-tax/'
const tax = {
  list: ({ opt = {} }) => axios.get(path4, opt),
  create: ({ form, opt = {} }) => axios.post(path4, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${path4}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${path4}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${path4}${pk}/`)
}

// Paquetes para crear una empresa
const path5 = 'packages/'
const packages = {
  list: ({ opt = {} }) => axios.get(path5, opt),
  create: ({ form, opt = {} }) => axios.post(path5, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.put(`${path5}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${path5}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${path5}${pk}/`)
}

// Pagos de paquetes
const path6 = 'payment/'
const payment = {
  list: ({ opt = {} }) => axios.get(path6, opt),
  create: ({ form, opt = {} }) => axios.post(path6, form, opt),
  edit: ({ pk, form, opt = {} }) => axios.patch(`${path6}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${path6}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${path6}${pk}/`)
}

export default {
  list,
  create,
  edit,
  show,
  tenantGuide,
  remove,
  download_backup,
  restore_backup,
  contact,
  tax,
  packages,
  payment
}
